import React from "react";
import { Grid, withStyles, Typography } from "@material-ui/core";

const ContainerSection = ({title, subtitle, children}) => {

  return (
    <Grid container>
      <Grid item container xs={12} direction="column">
          <Typography variant="h2"
            style={{
              color: "#262930",
              fontFamily: "Public Sans",
              textTransform: "capitalize",
              fontSize: "24px",
              fontWeight: 600,
              lineHeight: "24px",
              letterSpacing: "0em",
              textAlign: "left"
            }}
          >
            {title}
          </Typography>
          <Typography variant="p"
            style={{
              color: "#262930",
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "20px",
              letterSpacing: "0px",
              textAlign: "left",
            }}
          >
            {subtitle}
          </Typography>
      </Grid>
      <Grid item container xs={12} justifyContent="center" style={{paddingTop: '24px'}}>
        {children}
      </Grid>
    </Grid>
  )
}

export default ContainerSection;
